export enum UserType {
  Principal,
  Partner,
}
